import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

// This directive add signature sosh by setting black color on first word h2 title
@Directive({
    selector:
        'h2:not(.no-signature):not(.h1):not(.h3):not(.h4):not(.h5):not(.h6):not(.lead):not(.small),' +
        '.h2:not(.no-signature)',
})
export class MaterialSoshSignatureDirective implements AfterViewInit {
    /**
     * Constructor
     * @param {ElementRef} DOM element
     * @param {Renderer2} renderer element
     */
    public constructor(
        private element: ElementRef,
        private renderer: Renderer2,
    ) {}

    /**
     * Directive initialization
     */
    public ngAfterViewInit(): void {
        if (this.hasSpecificParentSelector('.apply-one-style') && this.hasSpecificParentSelector('.ecm-theme-sosh')) {
            const DOMElement: any = this.element.nativeElement;
            const title: string = DOMElement.innerText.trim();
            const firstWord: string = title.substring(0, title.indexOf(' '));
            const leftoverTitle: string = title.substring(title.indexOf(' '));

            const span: any = this.renderer.createElement('span');
            const innerSpanText: any = this.renderer.createText(firstWord);
            const innerLeftoverText: any = this.renderer.createText(leftoverTitle);

            this.renderer.addClass(span, 'text-dark');
            this.renderer.appendChild(span, innerSpanText);
            this.renderer.removeChild(DOMElement, DOMElement.firstChild);
            this.renderer.appendChild(DOMElement, span);
            this.renderer.appendChild(DOMElement, innerLeftoverText);
        }
    }

    /**
     * Find parent selector
     * @param {string} selector
     */
    private hasSpecificParentSelector(selector: string): boolean {
        let result = false;
        let currentElement: any = this.element.nativeElement;
        do {
            result = currentElement.matches
                ? currentElement.matches(selector)
                : currentElement.msMatchesSelector(selector);
            currentElement = currentElement.parentElement;
        } while (!result && currentElement instanceof HTMLElement);
        return result;
    }
}
